import type { PpCheckbox } from '../forms/Checkbox';
import type { PpDefaultListItemText } from '../lists/DefaultListItemText';
import { Checkbox } from '../forms/Checkbox';

type PpConsentOption = Omit<PpCheckbox, 'label'> & {
  label: PpDefaultListItemText;
};
export function ConsentOption({ label, ...rest }: PpConsentOption): React.ReactElement {
  return (
    <Checkbox
      label={label.primary}
      secondaryLabel={label.secondary}
      slotProps={{
        primary: { sx: { mb: 0.25 } },
      }}
      sx={{ alignSelf: 'flex-start', padding: (theme) => theme.spacing(0, 1) }}
      {...rest}
    />
  );
}
